// extracted by mini-css-extract-plugin
export var actions = "_ua-4";
export var item = "_ua-1";
export var price = "_ua-3";
export var quantity = "_ua-2";
export var table = "_ua-0";